module.exports = __webpack_public_path__ + "static/media/Tablet.411f3cfd.svg";